<template>
    <div v-if="visible" class="uik-loading-overlay">
        <UikLoader
            :type="loaderType"
            :color="loaderColor"
            :size="loaderSize"
        />
        <p v-if="text" class="uik-loading-overlay__text">{{ text }}</p>
        <UikOverlay :opacity="30"/>
    </div>
</template>

<script>
export default {
    name: "UikLoadingOverlay",
    props: {
        visible: {
            type: Boolean,
            default: true,
            required: true
        },
        text: {
            type: String,
            default: ""
        },
        loaderType: {
            type: String,
            default: "dots"
        },
        loaderSize: {
            type: Number,
            default: 1.2
        },
        loaderColor: {
            type: String,
            default: "white"
        }
    }
}
</script>

<style lang="scss">
.uik-loading-overlay {
   position: fixed;
   z-index: 10;
   top: 0;
   left: 0;
   width: 100%;
   height: 100vh;
   display: flex;
   flex-flow: column nowrap;
   justify-content: center;
   align-items: center;
   padding-bottom: 30px;
   .uik-loader {
       position: relative;
       z-index: 11;
   }
   .uik-loading-overlay__text {
       position: relative;
       z-index: 11;
       color: white;
       font-size: 1.3rem;
       font-weight: normal;
       margin: 30px 0 0 0;
       padding: 0 20px;
       user-select: none;
       & + * {
           margin: 0;
       }
   }
}
</style>
